import React, { Component } from 'react';
import { Table, } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import allStocks from '../../data/stock_us_filtered_sorted.json';

class StockDividendCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockDividendCalenderList: [],
        };
    }

    custom_sort(a, b) {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
    }

    componentDidMount() {
        ApiService.getStockDividendCalender(11)
            .then(result => {
                console.log('Stock Dividend Calender', result);
                let filteredData = [];
                let length = 15;
                if (result.length > 0) {
                   //Remove other country ticker
                   let tmpFiltered = [];
                   for (var i=0; i<result.length; i++){
                       for (var j=0; j<allStocks.length; j++){
                           if (result[i].symbol === allStocks[j].symbol && allStocks[j].type === 'stock'){
                               tmpFiltered.push(result[i]);
                               break;
                           }
                       }
                   }
                   result = tmpFiltered;

                    result.sort(this.custom_sort);
                    var helper = {};
                    filteredData = result.reduce(function (r, o) {
                        var key = o.date + '-' + o.time;

                        if (!helper[key]) {
                            helper[key] = Object.assign({}, o); // create a copy of o
                            r.push(helper[key]);
                        } else {
                            helper[key].symbol += ' ' + o.symbol;
                        }

                        return r;
                    }, []);
                    length = filteredData.length < length ? filteredData.length : length;
                    filteredData = filteredData.slice(0, length);
                    console.log('Stock Dividend Calender filter', result, filteredData);
                }
                this.setState({ stockDividendCalenderList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    rederSymbolRow(symbol) {
        if (symbol !== undefined) {
            let url = '/chart/' + symbol;
            return (
                <><Link to={url}>{symbol}</Link>{' '}{' '}{' '}</>
            )
        }
    }

    renderRow(listValue) {
        if (listValue !== undefined) {
            let allSymbols = listValue.symbol.split(' ');
            allSymbols = allSymbols.slice(0, 30);
            return (
                <tr key={listValue.symbol + Math.random()}>
                    <td>{listValue.date}</td>
                    <td style={{ overflowWrap: 'break-word', textAlign: 'left' }}>{allSymbols.map(this.rederSymbolRow.bind(this))}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.stockDividendCalenderList !== undefined && this.state.stockDividendCalenderList.length !== undefined && this.state.stockDividendCalenderList.length > 0) {
            tableRow = this.state.stockDividendCalenderList.map(this.renderRow.bind(this));
        } else {
            tableRow = <tr><td></td><td>No Data</td></tr>
        }
        console.log('stockDividendCalenderList', this.state.stockDividendCalenderList.length);
        return (
               //<div style={{ overflow: 'scroll', height: '475px' }}> 
            // <Card border="secondary" style={{ height: '475px' }}>
            // <Card.Header>Stock Dividend Calender</Card.Header>
         
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th style={{width:'8em'}}>Date</th>
                            <th><Link to={'/stockDividend'}>Stock Dividend Ticker</Link></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>    
          
            // </Card>
            //</div>
        );
    }
}

export default StockDividendCalender;
